import { Component, Input, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// import { TransformKeyPipe } from '../../pipes/transform-key.pipe';
// import { FIELD_MAPPING } from '../../constants/field-mapping';
// import { getValueByPath } from '../../utils/get-value-by-path';
import { TimezonePipe } from '../../pipes/timezone.pipe';

@Component({
  selector: 'app-login-logout',
  standalone: true,
  templateUrl: './login-logout.html',
  styleUrls: ['./login-logout.scss'],
  imports: [TimezonePipe],
})
export class LoginLogout {
  @Input() logData: any;

}

